export enum PermissionMatrixName {
	ADD = 'add',
	ALL = 'all',
	DELETE = 'delete',
	DOWNLOAD = 'download',
	MODIFY = 'modify',
	READ = 'read',
}

// NOTE: keep these ordered as they would be in the permission matrix
export const PERMISSION_MATRIX_NAMES = [
	PermissionMatrixName.READ,
	PermissionMatrixName.DOWNLOAD,
	PermissionMatrixName.ADD,
	PermissionMatrixName.MODIFY,
	PermissionMatrixName.DELETE,
	PermissionMatrixName.ALL,
] as const;

export enum PermissionMode {
	READ = 'read',
	WRITE = 'write',
	DELETE = 'delete',
}
